// Per-host AuthKit redirect: keep the configured callback PATH, swap the host for the
// current origin so a login started on acme.cloudhouse.com returns to acme — validated
// by the WorkOS wildcard https://*.cloudhouse.com/post-signin.
export function originRedirectUri(configuredRedirectUri: string, origin: string): string {
  const path = new URL(configuredRedirectUri, origin).pathname;
  return new URL(path, origin).toString();
}
